// extracted by mini-css-extract-plugin
export default {"homeProject":"homeproject_homeProject__DbkjP"};